var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("NAICS Lists")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-blue float-right create-btn ml-1",
                      on: {
                        click: function($event) {
                          ;(_vm.isUploadModalVisible = true),
                            _vm.verrors.clear()
                        }
                      }
                    },
                    [_vm._v("\n        Upload CSV\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-blue float-right create-btn",
                      on: {
                        click: function($event) {
                          ;(_vm.isModalVisible = true), _vm.verrors.clear()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("NAICS\n      ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "b-navbar",
                      {
                        attrs: {
                          toggleable: "lg",
                          type: "light",
                          variant: "light"
                        }
                      },
                      [
                        _c("b-navbar-brand", { attrs: { href: "#" } }, [
                          _vm._v("Filter/Search")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-navbar-toggle",
                          { attrs: { target: "nav-collapse" } },
                          [_c("i", { staticClass: "fa fa-chevron-down\t" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          { attrs: { id: "nav-collapse", "is-nav": "" } },
                          [
                            _c(
                              "div",
                              { staticClass: "search-wrapper col-12" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row col-12 override-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-4 col-md-6 col-6"
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "input-text",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Description"
                                          },
                                          model: {
                                            value: _vm.search_description,
                                            callback: function($$v) {
                                              _vm.search_description = $$v
                                            },
                                            expression: "search_description"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-4 col-md-6 col-6"
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "input-text",
                                          attrs: {
                                            type: "text",
                                            placeholder: "NAICS Number"
                                          },
                                          model: {
                                            value: _vm.search_code,
                                            callback: function($$v) {
                                              _vm.search_code = $$v
                                            },
                                            expression: "search_code"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-10 col-10"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.naicsIdOptions
                                          },
                                          model: {
                                            value: _vm.search_naicsid,
                                            callback: function($$v) {
                                              _vm.search_naicsid = $$v
                                            },
                                            expression: "search_naicsid"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.filterNaicslistitems()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "search-icon" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-search"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("div", { staticClass: "row tasks_heading_row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("naicsId")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n               NAICS ID\n               "
                              ),
                              _vm.sortField == "naicsId" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "naicsId" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("naicsCode")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n               NAICS Number\n               "
                              ),
                              _vm.sortField == "naicsCode" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "naicsCode" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("description")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n               NAICS Description\n               "
                              ),
                              _vm.sortField == "description" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "description" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            staticClass: "loading_show"
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-danger"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.naics_lists.length > 0
                          ? _c(
                              "b-card-text",
                              [
                                _vm._l(_vm.naics_lists, function(
                                  naicslist,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "tasklist-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row tasklist-item",
                                          staticStyle: { margin: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 naics-title"
                                            },
                                            [_vm._v(_vm._s(naicslist.naicsCat))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(naicslist.naicsCode)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(naicslist.description)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown",
                                                  attrs: {
                                                    id:
                                                      "dropdown-container" +
                                                      index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleDropdown(
                                                        "actionDropdown" +
                                                          index +
                                                          ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropbtn icons btn-right showLeft",
                                                      attrs: {
                                                        id:
                                                          "dotted-menu" + index
                                                      }
                                                    },
                                                    [
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-content",
                                                      attrs: {
                                                        id:
                                                          "actionDropdown" +
                                                          index
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "action-dd-menu",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToEdit(
                                                                naicslist
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "cursor-pointer fa fa-edit spacer-icon"
                                                          }),
                                                          _vm._v("Edit")
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [_c("hr")])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.rows > 25
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overflow-auto float-right pagination-wrapper"
                                      },
                                      [
                                        _c("b-pagination", {
                                          attrs: {
                                            "total-rows": _vm.rows,
                                            "per-page": _vm.perPage,
                                            "first-text": "First",
                                            "prev-text": "Prev",
                                            "next-text": "Next",
                                            "last-text": "Last",
                                            "hide-goto-end-buttons": false
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.showNaicsofPaginated()
                                            }
                                          },
                                          model: {
                                            value: _vm.currentPage,
                                            callback: function($$v) {
                                              _vm.currentPage = $$v
                                            },
                                            expression: "currentPage"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm.loading == false
                          ? _c("b-card-text", [
                              _vm._v(
                                "\n                  No NAICS found.\n             "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "CreateTasklistModal",
                {
                  attrs: { isModalVisible: _vm.isModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n    Loading...\n  ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Create NAICS")])]
                  ),
                  _vm._v(" "),
                  _vm.isModalVisible === true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c(
                          "div",
                          { staticClass: "col-lg-12 col-12 override-padding" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.naics_title,
                                  expression: "naics_title"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "col-12 input-height-30",
                              attrs: {
                                placeholder: "Description",
                                maxlength: "255",
                                name: "Description"
                              },
                              domProps: { value: _vm.naics_title },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.naics_title = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule("Description", "required")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Description is required")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-12 float-left override-padding"
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "input-text",
                                attrs: {
                                  options: _vm.naicsIdOptions,
                                  name: "NAICS ID"
                                },
                                model: {
                                  value: _vm.naics_id,
                                  callback: function($$v) {
                                    _vm.naics_id = $$v
                                  },
                                  expression: "naics_id"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("NAICS ID", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS ID is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-12 float-left override-padding naics-code-wrapper"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.naics_code,
                                    expression: "naics_code"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|numeric",
                                    expression: "'required|numeric'"
                                  }
                                ],
                                staticClass: "col-12 input-height-30",
                                attrs: {
                                  placeholder: "NAICS Number",
                                  maxlength: "5",
                                  name: "NAICS Number"
                                },
                                domProps: { value: _vm.naics_code },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.naics_code = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "NAICS Number",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS Number is required")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("NAICS Number", "numeric")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS Number should be numeric")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-blue col-3 float-left input-height-25",
                              on: {
                                click: function($event) {
                                  return _vm.createNaicsAction()
                                }
                              }
                            },
                            [_c("b", [_vm._v("Create")])]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "EditNaicsModal",
                {
                  attrs: {
                    isModalVisible: _vm.isEditModalVisible,
                    editNaicsTitle: _vm.editNaicsTitle,
                    editNaicsCode: _vm.editNaicsCode,
                    editNaicsId: _vm.editNaicsId,
                    editId: _vm.editId
                  },
                  on: {
                    close: function($event) {
                      _vm.isEditModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n    Loading...\n  ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Edit NAICS")])]
                  ),
                  _vm._v(" "),
                  _vm.isEditModalVisible === true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c(
                          "div",
                          { staticClass: "col-lg-12 col-12 override-padding" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.editNaicsTitle,
                                  expression: "editNaicsTitle"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "col-12 input-height-30",
                              attrs: {
                                placeholder: "Description",
                                maxlength: "255",
                                name: "editNaicsTitle"
                              },
                              domProps: { value: _vm.editNaicsTitle },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.editNaicsTitle = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "editNaicsTitle",
                              "required"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Description is required")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-12 float-left override-padding"
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "input-text",
                                attrs: {
                                  options: _vm.naicsIdOptions,
                                  name: "editNaicsId"
                                },
                                model: {
                                  value: _vm.editNaicsId,
                                  callback: function($$v) {
                                    _vm.editNaicsId = $$v
                                  },
                                  expression: "editNaicsId"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("editNaicsId", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS ID is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-12 float-left override-padding naics-code-wrapper"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editNaicsCode,
                                    expression: "editNaicsCode"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|numeric",
                                    expression: "'required|numeric'"
                                  }
                                ],
                                staticClass: "col-12 input-height-30",
                                attrs: {
                                  placeholder: "NAICS Number",
                                  name: "editNaicsCode",
                                  maxlength: "5"
                                },
                                domProps: { value: _vm.editNaicsCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.editNaicsCode = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "editNaicsCode",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS Number is required")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "editNaicsCode",
                                "numeric"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("NAICS Number should be numeric")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-blue col-3 float-left input-height-25",
                              on: {
                                click: function($event) {
                                  return _vm.updateNaics()
                                }
                              }
                            },
                            [_c("b", [_vm._v("Update")])]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "UploadNaicsModal",
                {
                  attrs: { isModalVisible: _vm.isUploadModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isUploadModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n    Loading...\n  ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Upload CSV")])]
                  ),
                  _vm._v(" "),
                  _vm.isUploadModalVisible === true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _vm.isInitial || _vm.isSaving
                          ? _c(
                              "form",
                              {
                                attrs: {
                                  enctype: "multipart/form-data",
                                  novalidate: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-12 col-12 override-padding"
                                  },
                                  [
                                    _c("div", { staticClass: "dropbox" }, [
                                      _c("input", {
                                        staticClass: "input-file",
                                        attrs: {
                                          type: "file",
                                          name: "naics_csv",
                                          disabled: _vm.isSaving,
                                          accept: "type/csv",
                                          rules: "required"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.filesChange(
                                              $event.target.name,
                                              $event.target.files
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.isInitial
                                        ? _c("p", [
                                            _vm._v(
                                              "Drag your file(s) here to begin"
                                            ),
                                            _c("br"),
                                            _vm._v(" or click to browse")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSaving
                                        ? _c("p", [
                                            _vm._v(" Uploading file... ")
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _vm.uploadError
                                      ? _c(
                                          "p",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(_vm.uploadError))]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "margin-bottom-10",
                                  staticStyle: { clear: "both" }
                                })
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6167ac87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6167ac87","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/naics_list.vue
// module id = null
// module chunks = 